const STORAGE_KEYS = {
  TOKEN: '@token',
};

export default STORAGE_KEYS;
